export const projectdata = [
    {
        "projectName": "O-Connect",
        "Techologies": "Node.js, Express.js, MongoDB, Serverless with AWS Lambda and React.js",
        "discription": "It is a video conferencing platform and online meeting tool. With it, users can seamlessly connect,collaborate, and communicate."
    }, {
        "projectName": "O-Pal",
        "Techologies": "Node.js, Express.js, MongoDB, Serverless with AWS Lambda, socket.io , Redis, React.js and React Native",
        "discription": "It is a messaging platform with audio and video call features."
    }, {
        "projectName": "School Management System",
        "Techologies": "React.js, Node.js, Express.js, MonogoDB",
        "discription": "This module maintains a database of student records, including personal details, contact information, academic performance, attendance history, and disciplinary records."
    }, {
        "projectName": "calculator",
        "Techologies": "React.js ",
        "discription": "This allows users to perform fundamental arithmetic operations such as addition, subtraction, multiplication, and division. These operations are usually performed using the numeric keypad and corresponding function keys."
    }
]